<a appBackButton class="pointer"> < Volver</a>
<div
  class="jumbotron animated fadeIn fast"
  appCapslockOn
  (capslockOn)="capslockOn = $event"
>
  <div class="container-fluid">
    <label class="title primary">Crear nuevo usuario</label>
    <app-alert *ngIf="capslockOn" [alert]="capsWarning"></app-alert>
    <app-alert *ngIf="error" [alert]="error"></app-alert>
    <div class="">
      <app-loading *ngIf="loading"></app-loading>
      <form
        [formGroup]="form"
        *ngIf="!loading"
        class="form-pages"
        appBlockCopyPaste
      >
        <div class="row">
          <div class="col-md-6">
            <div
              class="form-group"
              [class.has-error]="helpers.invalidControl(form.get('firstName'))"
            >
              <label class="label-form" for="">Nombre</label>
              <input
                type="text"
                class="form-control"
                formControlName="firstName"
                maxlength="20"
              />
              <span
                class="help-block invalid-feedback"
                *ngIf="helpers.invalidControl(form.get('firstName'))"
              >
                <span *ngIf="form.get('firstName').errors.required">{{
                  constants.validations.required.message
                }}</span>
                <span *ngIf="form.get('firstName').errors.pattern">{{
                  constants.validations.alphabetic.message
                }}</span>
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <div
              class="form-group"
              [class.has-error]="helpers.invalidControl(form.get('lastName'))"
            >
              <label class="label-form" for="">Apellidos</label>
              <input
                type="text"
                class="form-control"
                formControlName="lastName"
                maxlength="20"
              />
              <span
                class="help-block invalid-feedback"
                *ngIf="helpers.invalidControl(form.get('lastName'))"
              >
                <span *ngIf="form.get('lastName').errors.required">{{
                  constants.validations.required.message
                }}</span>
                <span *ngIf="form.get('lastName').errors.pattern">{{
                  constants.validations.alphabetic.message
                }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div
              class="form-group has-feedback"
              [class.has-error]="helpers.invalidControl(form.get('docType'))"
            >
              <label class="label-form" for="">Tipo de documento</label>
              <select
                class="form-control"
                formControlName="docType"
                (change)="onChange($event)"
              >
                <option value="" disabled selected>Selecciona</option>
                <option *ngFor="let type of docTypes" value="{{ type.value }}">
                  {{ type.name }}
                </option>
              </select>
              <i
                class="glyphicon glyphicon-menu-down form-control-feedback custom-select-arrow"
              ></i>

              <span
                class="help-block invalid-feedback"
                *ngIf="helpers.invalidControl(form.get('docType'))"
              >
                <span *ngIf="form.get('docType').errors.required">{{
                  constants.validations.required.message
                }}</span>
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <div
              class="form-group"
              [class.has-error]="helpers.invalidControl(form.get('docNumber'))"
            >
              <label class="label-form" for="">Número de documento</label>
              <input
                type="text"
                class="form-control"
                formControlName="docNumber"
                [maxlength]="maxLengthDoc"
                mask="0*"
              />
              <span
                class="help-block invalid-feedback"
                *ngIf="helpers.invalidControl(form.get('docNumber'))"
              >
                <span *ngIf="form.get('docNumber').errors.required">{{
                  constants.validations.required.message
                }}</span>
                <span
                  *ngIf="
                    form.get('docNumber').errors.pattern ||
                    form.get('docNumber').errors.minlength ||
                    form.get('docNumber').errors.maxlength
                  "
                  >{{
                    constants.validations.docNumber.message(
                      form.get("docNumber").errors.minlength?.requiredLength || maxLengthDoc
                    )
                  }}</span
                >
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div
              class="form-group"
              [class.has-error]="helpers.invalidControl(form.get('email'))"
            >
              <label class="label-form" for="">Correo</label>
              <input
                type="text"
                maxlength="60"
                class="form-control"
                formControlName="email"
              />
              <span
                class="help-block invalid-feedback"
                *ngIf="helpers.invalidControl(form.get('email'))"
              >
                <span *ngIf="form.get('email').errors.required">{{
                  constants.validations.required.message
                }}</span>
                <span *ngIf="form.get('email').errors.pattern">{{
                  constants.validations.email.message
                }}</span>
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <div
              class="form-group"
              [class.has-error]="helpers.invalidControl(form.get('phone'))"
            >
              <label class="label-form" for="">Número de teléfono</label>
              <input
                id="phone"
                type="text"
                class="form-control"
                formControlName="phone"
                prefix="+51 9 "
                mask="0*"
                [validation]="true"
                maxlength="14"
                (click)="onClickImputTel($event)"
                (keyup)="onClickImputTel($event)"
              />
              <span
                class="help-block invalid-feedback"
                *ngIf="helpers.invalidControl(form.get('phone'))"
              >
                <span *ngIf="form.get('phone').errors.required">{{
                  constants.validations.required.message
                }}</span>
                <span *ngIf="form.get('phone').errors.minlength">{{
                  constants.validations.invalidPhone.message
                }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div
              class="form-group"
              [class.has-error]="helpers.invalidControl(form.get('charge'))"
            >
              <label class="label-form" for="">Cargo en la empresa</label>
              <input
                type="text"
                class="form-control"
                formControlName="charge"
                maxlength="60"
              />
              <span
                class="help-block invalid-feedback"
                *ngIf="helpers.invalidControl(form.get('charge'))"
              >
                <span *ngIf="form.get('charge').errors.required">{{
                  constants.validations.required.message
                }}</span>
                <span *ngIf="form.get('charge').errors.pattern">{{
                  constants.validations.alphabetic.message
                }}</span>
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <div
              class="form-group has-feedback"
              (click)="onClickSelect()"
              [class.has-error]="helpers.invalidControl(form.get('role'))"
            >
              <label class="label-form" for="">Perfil</label>
              <ng-multiselect-dropdown
                [placeholder]="'Selecciona'"
                (onDropDownClose)="onDropDownClose()"
                [settings]="dropdownSettings"
                [data]="roles"
                formControlName="role"
                noDataAvailablePlaceholderText="No disponible"
              >
              </ng-multiselect-dropdown>
              <i
                class="glyphicon glyphicon-menu-down form-control-feedback custom-select-arrow"
              ></i>
              <!-- <i class="glyphicon glyphicon-menu-up form-control-feedback custom-select-arrow"></i> -->
              <!-- <select class="form-control" formControlName="role">
                <option value="" disabled selected>Seleccione</option>
                <option *ngFor="let role of roles" value="{{ role.uri }}">
                  {{ role.name | titlecase }}
                </option>
              </select> -->
              <span
                class="help-block invalid-feedback"
                *ngIf="helpers.invalidControl(form.get('role'))"
              >
                <span *ngIf="form.get('role').errors.required">{{
                  constants.validations.required.message
                }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="row text-center">
          <button
            (click)="create()"
            [disabled]="form.invalid || !roles"
            class="button-continue button-find-label"
          >
            Crear usuario
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
